import { http } from '../../../api'

const settings = {
  namespaced: true,
  state: {
    settingsList: []
  },
  actions: {
    getSettingsList: ({ commit }) => {
      return http.get('/settings').then(res => {
        commit('setSettingsList', res.data.data)
      })
    },
    updateSettings: ({ commit }, params) => {
      return http.post('/settings', params.data).then(res => {
        commit('setSettingsList', res.data.data)
        return res.data.data
      })
    }
  },
  mutations: {
    setSettingsList (state, data) {
      state.settingsList = data
    }
  },
  getters: {
    settingsList: state => state.settingsList
  }
}

export default settings
